import { SmartlookEvents } from "@/constants/smartlook-events";
import { trackOnboardingV5StepViewed } from "@/features/onboarding/analytics";
import { setSmartlookEvent, setSmartlookPage, trackOnboardingPage } from "@/utils/smartlook";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const usePageTracking = () => {
  const location = useLocation();
  const previousTimeRef = useRef(Date.now());
  const previousPathRef = useRef(location.pathname);

  useEffect(() => {
    const now = Date.now();

    if (previousPathRef.current !== location.pathname) {
      const durationSec = (now - previousTimeRef.current) / 1000;
      setSmartlookEvent(SmartlookEvents.PAGE_STAY_TIME, {
        pathname: previousPathRef.current,
        page_stay_time: Math.round(durationSec),
      });
    }

    setSmartlookPage(location.pathname);

    trackOnboardingPage(location.pathname);
    trackOnboardingV5StepViewed(location.pathname);

    previousTimeRef.current = now;
    previousPathRef.current = location.pathname;
  }, [location.pathname]);
};
